export default __webpack_public_path__ + "static/media/STL_FInancials_Consolidated_March_2026.6f06b2bc.pdf";